export const PAYLOAD_ENCRYPTION = process.env.REACT_APP_PAYLOAD_ENCRYPTION === "true";

const TAG_LENGTH = 16;

const toHex = (bytes) => Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
const fromHex = (hex) => new Uint8Array(hex.match(/../g).map((h) => parseInt(h, 16)));

let keyPromise;
const getKey = () => {
  if (!keyPromise) {
    keyPromise = crypto.subtle.importKey(
      "raw",
      fromHex(process.env.REACT_APP_PAYLOAD_ENCRYPTION_KEY || ""),
      "AES-GCM",
      false,
      ["encrypt", "decrypt"]
    );
  }
  return keyPromise;
};

export async function encryptPayload(obj) {
  const iv = crypto.getRandomValues(new Uint8Array(16));
  const sealed = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv }, await getKey(), new TextEncoder().encode(JSON.stringify(obj)))
  );
  const ct = sealed.slice(0, -TAG_LENGTH);
  const tag = sealed.slice(-TAG_LENGTH);
  return `${toHex(iv)}:${toHex(tag)}:${toHex(ct)}`;
}

export async function decryptPayload(str) {
  const [iv, tag, ct] = str.split(":").map(fromHex);
  const sealed = new Uint8Array(ct.length + tag.length);
  sealed.set(ct);
  sealed.set(tag, ct.length);
  const plain = await crypto.subtle.decrypt({ name: "AES-GCM", iv }, await getKey(), sealed);
  return JSON.parse(new TextDecoder().decode(plain));
}

// Decrypts { payload } bodies; plain bodies pass through untouched.
export async function decryptIfEncrypted(data) {
  return data && typeof data.payload === "string" ? decryptPayload(data.payload) : data;
}
